import { Column, Entity, Index, JoinColumn, ManyToOne, Unique } from 'typeorm';
import { BaseEntity } from './base.entity';
import { LegacyEmailTemplateEntity } from './legacy-email-template.entity';
import { TagEntity } from './tag.entity';

@Unique('_email_template_tag_unique', ['fkEmailTemplateId', 'fkTagId'])
@Index('_fk__tag__id', ['fkTagId'], {})
@Entity('_email_template__tag')
export class LegacyEmailTemplateTagEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__email_template__id',
		nullable: true,
		unsigned: true,
	})
	public fkEmailTemplateId!: number | null;

	@Column('int', { name: '_fk__tag__id', nullable: true, unsigned: true })
	public fkTagId!: number | null;

	@ManyToOne(
		() => LegacyEmailTemplateEntity,
		(emailTemplate) => emailTemplate.emailTemplateTags,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk__email_template__id', referencedColumnName: 'id' }])
	public fkEmailTemplate!: LegacyEmailTemplateEntity | null;

	@ManyToOne(() => TagEntity, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__tag__id', referencedColumnName: 'id' }])
	public fkTag!: TagEntity | null;
}
